import React from 'react'
import { connect } from 'react-redux'

import Button from 'components/Button'

import { SETTINGS_PAGINATION, MODAL_ALERT_TYPES } from 'utils/consts'
import actions from 'store/actions'

import closeBtn from 'assets/images/close.svg'

class ModalNewGroup extends React.Component {
  state = {
    groupName: '',
    errorText: '',
  }

  /**
   * @param {Object} e
   */
  handleChangeInput = e => {
    this.setState({ groupName: e.target.value })
  }

  createGroup = async () => {
    if (!this.state.groupName.trim()) {
      this.setState({ errorText: 'Укажите название группы' })
    } else {
      try {
        const data = [
          { title: this.state.groupName.trim(), employee_id: [], access_object_id: [] },
        ]

        this.props.closeModal()
        await this.props.createGroup(data)
        await this.props.fetchGroups({
          count: SETTINGS_PAGINATION.COUNT_PER_PAGE,
          page: SETTINGS_PAGINATION.PAGE_NUMBER,
        })
      } catch (error) {
        this.props.openModalAlert(MODAL_ALERT_TYPES.TYPE_ERROR, error)
      }
    }
  }

  render() {
    const { errorText } = this.state

    return (
      <div className='modal-overlay'>
        <div className='modal modal--sm'>
          <div className='modal__header'>
            <p className='modal__title'>Создание группы сотрудников</p>
            <Button
              className='button--icon'
              icon={true}
              iconPicture={closeBtn}
              action={this.props.closeModal}
            />
          </div>

          <div className='modal__content'>
            {errorText && <div className='error'>{errorText}</div>}
            <input
              type='input'
              className='input input--lg'
              placeholder='Название'
              onChange={this.handleChangeInput}
            />
          </div>

          <div className='modal__bottom modal__bottom--right'>
            <Button
              title='Создать'
              className='btn--lg btn--primary'
              action={this.createGroup}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    createGroup: data => dispatch(actions.groups.createGroup(data)),
    fetchGroups: data => dispatch(actions.groups.fetchGroups(data)),
  }
}

export default connect(null, mapDispatchToProps)(ModalNewGroup)
